<template>
  <div class="VotingWholeCity">
    <div class="index-header">
      <span class="title">
        <i class="el-icon-caret-right"></i>全市投票表决统计
      </span>
      <span class="other more"></span>
    </div>
    <div class="VotingWholeCity-main">
      <div>
        <div class="dateChoose">
          <span :class="{ active: tabname=='3'  }" @click="changeData(3)">近3个月</span>
          <span :class="{ active: tabname=='6'  }" @click="changeData(6)">近6个月</span>
          <span :class="{ active: tabname=='12'  }" @click="changeData(12)">近1年</span>
          <span :class="{ active: tabname=='all'  }" @click="toVoteList">全部</span>
        </div>
      </div>
      <div style="display: flex;justify-content: center;">
        <div id="myChartVotingCity" :style="{width: '700px', height: '190px'}"></div>
      </div>
    </div>
  </div>
</template>

<script>
import commonTitle from '@/assets/js/commonTitle.js';
import { mapState } from 'vuex';
import { HomePageControllerSvr } from '@/service/HomePageControllerSvr/HomePageControllerSvr';

export default {
  components: {},
  props: {},
  data() {
    return {
      tabname: '6',
      Position: 'running',
      data: ''
    };
  },
  computed: {
    ...mapState(['token']),
    mainTitle: () => {
      return commonTitle;
    }
  },
  created() {
    this.HomePageControllerSvr = new HomePageControllerSvr();
  },
  mounted() {
    this.getdata(this.tabname);
  },
  methods: {
    changeData(index) {
      this.getdata(index);
    },
    getdata(index) {
      this.tabname = index;
      this.HomePageControllerSvr.CityVoteStatistics(this.token, index).then(
        res => {
          this.data = res;
          this.drawPie();
        }
      );
    },
    drawPie() {
      //投诉统计
      let myChartVoteWhole = this.$echarts.init(
        document.getElementById('myChartVotingCity')
      );
      //展示月份数组
      const monthArray = [];
      //总数数组
      const totalArray = [];
      //通过属猪
      const passArray = [];

      for (const item of this.data) {
        for (const key in item) {
          monthArray.push(key);
          totalArray.push(item[key][0]);
          passArray.push({
            value: item[key][1],
            itemStyle: {
              normal: {
                color: '#0f77f2'
              }
            }
          });
        }
      }
      //最大事项数
      let maxNum = Math.max.apply(null, totalArray);
      //
      maxNum = Math.ceil(maxNum / 10) * 10;

      var chartName = ['业委会选举', '维修资金使用', '其他'];
      var chartData = ['58', '30', '12'];
      var data = [];
      var legendName = [];
      for (var i = 0; i < chartData.length; i++) {
        var c = {
          value: chartData[i],
          name: chartName[i] + '  ' + chartData[i] + '%'
        };
        data[i] = c;
        legendName[i] = chartName[i] + '  ' + chartData[i] + '%';
      }
      myChartVoteWhole.setOption({
        tooltip: {
          trigger: 'axis',
          formatter: '（单位：件数）',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#0f77f2'
            }
          }
        },

        xAxis: [
          {
            type: 'category',
            show: true,
            data: monthArray,
            axisPointer: {
              type: 'shadow'
            },
            axisTick: {
              show: false
            }
          }
        ],

        yAxis: [
          {
            type: 'value',
            name: '（单位：件数）',
            min: 0,
            max: maxNum * 1.1,
            interval: maxNum / 5,
            axisLabel: {
              formatter: '{value}'
            },
            axisTick: {
              show: false
            }
          }
        ],
        legend: {
          data: ['通过事项数', '总事项数'],
          right: 20
        },
        series: [
          {
            name: '通过事项数',
            type: 'bar',
            center: ['90%', '100%'],
            barWidth: '10%',
            color: ['#0f77f2'],
            data: passArray
          },
          {
            type: 'line',
            name: '总事项数',
            smooth: true,
            data: totalArray,
            color: ['#ffb11a']
          }
        ]
      });
    },
    toVoteList() {
      this.$router.push('/voteList');
    }
  }
};
</script>
<style lang="scss">
@import './css/common.scss';
.VotingWholeCity {
  background-color: #fff;
  .index-header {
    .more {
      color: blue;
    }
  }
  .VotingWholeCity-main {
    background-color: #fff;
    height: 210px;
    .dateChoose {
      text-align: left;
      span {
        line-height: 30px;
        padding: 10px;
        font-family: 'MicrosoftYaHei';
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #333333;
        cursor: pointer;
      }
      .active {
        color: #0f77f2;
        border-bottom: 3px solid;
      }
    }
    .productType {
      .productType1 {
        text-align: center;
        margin-top: 40px;
      }
      .productType2 {
        text-align: center;
        margin-top: 30px;
      }
      .productType3 {
        text-align: center;
        margin-top: 20px;
        //图标对齐
        .svgMragin {
          display: flex;
          align-items: flex-end;
          justify-content: center;
        }
      }
    }
    //长竖线
    .vertaline {
      width: 1%;
      height: 210px;
      div {
        width: 1px;
        height: 80%;
        background-color: #e2e2e2;
        margin-top: 21px;
      }
    }
    //短竖线
    .vertalineShort {
      width: 1%;
      height: 50px;
      div {
        width: 1px;
        height: 100%;
        background-color: #e2e2e2;
      }
    }
    //数字样式
    .numFontSizeBlue {
      width: 27px;
      height: 18px;
      font-family: MicrosoftYaHei-Bold;
      font-size: 22px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #0f77f2;
    }
    //数字样式
    .bignumFontSizeBlue {
      width: 54px;
      height: 29px;
      font-family: MicrosoftYaHei-Bold;
      font-size: 34px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #0f77f2;
      .until {
        font-family: MicrosoftYaHei;
        font-size: 12px;
        font-weight: normal;
        letter-spacing: 0px;
        color: #0f77f2;
      }
    }
    //字体样式
    .FontSize {
      width: 26px;
      height: 14px;
      font-family: MicrosoftYaHei;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: -1px;
      color: #333333;
    }
  }
}
</style>